<template>
    <div class="table-cell table-cell7"> <!-- GOAL AMOUNT PROGRESS -->
        <div class="progress" @click="visible=!visible">
            <div class="progress-bar progress-bar-success" role="progressbar"
                 :style="percentage.styleValue" :aria-valuenow="percentage.intValue" aria-valuemin="0"
                 aria-valuemax="100">
                    <span>
                        <Poptip v-model="visible" placement="top" class="solid-btn">
                            {{percentage.humanValue}}
                            <div slot="content">
                                <div class="popover-content" style="max-width: 242px; display: block">
                                    <p style="color: #000; font-size: 14px;font-family: 'Rubik-Regular';max-width: 242px; word-break: break-all; display: block; text-align: center">
                                    This teacher only need<b style="color:#FD8204"> {{moneyNeeded}}</b><br> to complete<b style="color:#FD8204"> 100%</b> of the fund
                                    </p><br>
                                    <button class="solid-btn" @click="fullFunding">Fund it 100%<i class="fa fa-chevron-right" aria-hidden="true"></i></button>
                                </div>
                                <!--<div class="popover-box"> &lt;!&ndash; POPUP DONATION NEEDED &ndash;&gt;-->
                                <!--<div style="padding:20px;">-->
                                <!--<p>This teacher only need<span> $259</span> to complete<span> 100%</span> of the fund</p>-->
                                <!--<a href="#" class="solid-btn">-->
                                <!--Fund it 100%<i class="fa fa-chevron-right" aria-hidden="true"></i>-->
                                <!--</a>-->

                                <!--</div>-->
                                <!--</div>-->
                            </div>
                        </Poptip>
                    </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {

        },
        props: {
            fundraiserSlug:{required:true},
            raisedAmount: {required: true},
            goalAmount: {required: true},
            currentDonation: {required: false, default: 0}
        },
        data() {
            return {
                visible: false,
            }
        },
        computed: {
            percentage() {
                let intPercentage = (this.raisedAmount + this.currentDonation) * 100 / this.goalAmount;
                intPercentage = parseInt(intPercentage);
                console.log({
                    raised: this.raisedAmount, current: this.currentDonation, goal: this.goalAmount
                })
                return {
                    intValue: intPercentage,
                    styleValue: 'width: ' + intPercentage + '%',
                    humanValue: intPercentage + "%",
                }

            },
            moneyNeeded(){
                return '$'+(this.goalAmount - this.raisedAmount);
            }
        },
        methods:{
            fullFunding(){
                kinfEvents.$emit('FundingChange',{
                    fundraiserSlug:this.fundraiserSlug,
                    amount:(this.goalAmount - this.raisedAmount)
                });
            }
        }
    }
</script>

<style>
    .top, .bottom {
        text-align: center;
    }

    .center {
        width: 300px;
        margin: 10px auto;
        overflow: hidden;
    }

    .center-left {
        float: left;
    }

    .center-right {
        float: right;
    }

    .ivu-poptip-body {
        padding: 10px;
    }

    ivu-poptip-popper {
        box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
        border-radius: 6px;
    }

    .ivu-poptip{
        width: auto !important;
        padding: 3px 5px 5px 5px !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/checkout/components/index/cart-table-subcomponents/CartTableProgress.vue